import { createStore } from "vuex";

const MUSIC_KEY = "global_music_playing";

export default createStore({
  state: {
    // 从 sessionStorage 里恢复音乐播放状态，默认 true（首次进入默认播放）
    isMusicPlaying: sessionStorage.getItem(MUSIC_KEY) !== "0",
  },
  getters: {
    isMusicPlaying: (state) => state.isMusicPlaying,
  },
  mutations: {
    setMusicPlaying(state, playing) {
      state.isMusicPlaying = playing;
      sessionStorage.setItem(MUSIC_KEY, playing ? "1" : "0");
    },
  },
  actions: {},
  modules: {},
});
